import { countryCodes } from '@ovpn-ui/utils';

export type CountryIso = keyof typeof countryCodes;

export const Continents = {
    NA: 'North America',
    SA: 'South America',
    EU: 'Europe',
    AS: 'Asia',
    AF: 'Africa',
    AU: 'Australia',
} as const;

export type VpnRegion = {
    id: string;
    regionName: string;
    city: string;
    continent: string;
    country: string;
    countryIso: CountryIso;
    hostName: string;
};

export type VpnRegionsMap = Record<string, VpnRegion>;

export type VpnRegionsList = VpnRegion[];
